import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/css/Login/Login.css';
import loadingGif from '../../../assets/video/loding.gif';

const API_BASE_URL = process.env.REACT_APP_API_URL;

console.log(API_BASE_URL);


function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(false);
  const [companyInfo, setCompanyInfo] = useState({ companyName: '', companyLogo: '' });

  // Redirect if already logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (token && isLoggedIn === 'true') {
      navigate('/dashboard');
    }
  }, [navigate]);

  // Fetch company logo and name
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/settings`);
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          const settings = response.data[0];
          setCompanyInfo({
            companyName: settings.companyName?.trim() || 'Welcome',
            companyLogo: settings.companyLogo || ''
          });
        }
      } catch (err) {
        console.error('Failed to load company settings', err);
      }
    };

    fetchSettings();
  }, []);

  // Redirect after login
  useEffect(() => {
    if (redirectAfterLogin) {
      const timeout = setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [redirectAfterLogin, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/users/login`, {
        email,
        password
      });

      if (response.data.success) {
        const { token, user } = response.data;

        localStorage.setItem('token', token);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('email', user.email);
        localStorage.setItem('role', JSON.stringify(user.role));
        localStorage.setItem('permissions', JSON.stringify(user.permissions || []));
        localStorage.setItem('userId', user._id);  // ✅ correct key
        localStorage.setItem('name', user.name);   // ✅ correct key
        localStorage.setItem('addresses', JSON.stringify(user.address));
        localStorage.setItem('user', JSON.stringify(user));
        //  console.log('Stored addresses:', JSON.parse(localStorage.getItem('addresses')));
        // console.log('Stored Login Data:', {
        //   token: localStorage.getItem('token'),
        //   isLoggedIn: localStorage.getItem('isLoggedIn'),
        //   email: localStorage.getItem('email'),
        //   role: JSON.parse(localStorage.getItem('role')),
        //   permissions: JSON.parse(localStorage.getItem('permissions')),
        //   userId: localStorage.getItem('userId'),
        //   name: localStorage.getItem('name'),       // ✅ this will now exist

        // });
        setRedirectAfterLogin(true);

      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  // Loading screen
  if (loading || redirectAfterLogin) {
    return (
      <div className="login-container">
        <div className="loading-screen">
          <img src={loadingGif} alt="Loading..." />
          <p>Signing you in, please wait...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          {companyInfo.companyLogo && (
            <img
              src={`${API_BASE_URL}/uploads/${companyInfo.companyLogo}`}
              alt="Company Logo"
              className="company-logo"
            />
          )}
          <h3>{companyInfo.companyName || 'Welcome'}</h3>
        </div>

        <div className="login-right">
          <form onSubmit={handleLogin}>
            <h2>Sign in</h2>
            <p className="subtext">Login using your credentials</p>

            {error && <p className="error-text">{error}</p>}

            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
                required
              />
            </div>

            <div className="input-group password-input">
              <label>Password</label>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{ marginTop: '16px' }}
              >
                {showPassword ? 'HIDE' : 'SHOW'}
              </button>
            </div>

            <button className="btn-primary" type="submit">
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
